var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", { staticClass: "contactum-label" }, [
      _vm._v(_vm._s("Map Settings"))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(" " + _vm._s("Set default co-ordinate and zoom level") + " ")
    ]),
    _vm._v(" "),
    _c("input", {
      staticClass: "contactum-google-map-search",
      attrs: { type: "text", placeholder: "Search address" }
    }),
    _vm._v(" "),
    _c("label", { staticClass: "contactum-label" }, [
      _vm._v(_vm._s("Show Address Search Box") + " ")
    ]),
    _vm._v(" "),
    _c("input", {
      staticClass: "contactum-google-map-searh",
      attrs: { type: "checkbox", name: "" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "contactum-field-google-map" }),
    _vm._v(" "),
    _c("div", [
      _c("ul", [
        _c("li", [
          _c("label", [
            _c("input", {
              attrs: { type: "checkbox" },
              domProps: { checked: "yes" === _vm.editfield.address },
              on: {
                click: function($event) {
                  return _vm.toggle_checkbox_field("address")
                }
              }
            }),
            _vm._v(" Show address search box\n              ")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }